import { IEscrowBankAccountResponse } from 'types/accounting/response/IEscrowBankAccountResponse';
import { ISODateString } from 'types/shared/ISODateString';
import { ISODateTimeString } from '../../shared/ISODateTimeString';
import { IHoldbackDisbursement } from './IHoldbackDisbursement';
import { eVoidReason } from 'types/accounting/eVoidReason';

export enum eWireDisbursementsCategories {
  Payoff = 'payoff',
  DueToBorrower = 'due_to_borrower',
  DueToSeller = 'due_to_seller',
  ThirdParty = 'third_party',
}

export const prettyWireDisbursementsCategories: Record<eWireDisbursementsCategories, string> = {
  [eWireDisbursementsCategories.Payoff]: 'Payoff',
  [eWireDisbursementsCategories.DueToBorrower]: 'Due To Borrower',
  [eWireDisbursementsCategories.DueToSeller]: 'Due To Seller',
  [eWireDisbursementsCategories.ThirdParty]: 'Third Party',
};

// from swagger. when we make an API call for the complete escrow file, this is the wire disbursement.
export interface IWireDisbursementResponse extends IHoldbackDisbursement {
  id: string;
  beneficiary: string;
  amountCents: number;
  escrowBankAccount: IEscrowBankAccountResponse;
  accountNumber?: string;
  routingNumber?: string;
  memo?: string;
  category: eWireDisbursementsCategories;
  wellsFargoTransactionNumber: string;
  enqueuedForDisbursementAt?: ISODateTimeString;
  sendAt?: ISODateTimeString;
  createdAt: ISODateTimeString;
  updatedAt: ISODateTimeString;
}

export interface IEscrowWireDisbursementsData extends IHoldbackDisbursement {
  id: string;
  beneficiary: string;
  amountCents?: number;
  escrowBankAccount: IEscrowBankAccountResponse;
  memo?: string;
  category: eWireDisbursementsCategories;
  wellsFargoTransactionNumber: string;
  enqueuedForDisbursementAt?: ISODateString;
  sendAt?: ISODateString;
  routingNumber?: string;
  bankName?: string;
  accountNumber?: string;
  createdAt?: ISODateTimeString;
  updatedAt?: ISODateTimeString;
  cdItemId?: string;
  statementFeeId?: string;

  //Voiding Things
  voidedAt?: ISODateTimeString;
  voidedBy?: string;
  voiderId?: string;
  voidReason?: eVoidReason;
  voidReasonDescription?: string;

  federalReferenceNumber?: string;
  completedAt?: ISODateString;
}
